<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Avtividad:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-text-field
              ref="name"
              v-model="name"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'La descripción no debe tener mas de 100 caracteres']"
              label="Nombre"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="4" xs="12">
            <v-select
              :items="type_of_activities"
              label="Tipo de actividad"
              v-model="type_of_activity_id"
              name="type_of_activities"
              :item-text="'name'"
              :item-value="'id'"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-textarea
              outlined
              :maxlength="1000"
              :counter="1000"
              :rules="[v => (v || '' ).length <= 999 || 'La descripción no debe tener mas de 1000 caracteres']"
              ref="description"
              v-model="description"
              name="description"
              label="Descripción"
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-textarea
              outlined
              :maxlength="1000"
              :counter="1000"
              :rules="[v => (v || '' ).length <= 999 || 'La descripción no debe tener mas de 1000 caracteres']"
              ref="target_audience"
              v-model="target_audience"
              name="target_audience"
              label="Público objetivo"
            ></v-textarea>
          </v-col>

        </v-row>
      </v-sheet>

      <v-sheet
        width="100%"
        outlined
        class="mt-4"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Lugar y fecha:</h3>
          </v-col>

          <v-col cols="12">
            <v-text-field
              ref="place"
              v-model="place"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'El lugar no debe tener mas de 100 caracteres']"
              label="Lugar"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-switch
              v-model="all_day"
              :label="(all_day)?'La actividad dura todo el día':'La actividad requiere establecer horarios'"
            ></v-switch>
          </v-col>  

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              type="time"
              :disabled="all_day"
              v-model="start_time"
              outlined
              append-icon="mdi-clock"
              label="Hora de inicio"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              type="time"
              :disabled="all_day"
              v-model="finish_time"
              outlined
              append-icon="mdi-clock"
              label="Hora de finalización"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        outlined
        v-if="type_of_activity_id==3||type_of_activity_id==4">
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Auditorio Virtual:</h3>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-select
              :items="auditoriums"
              label="Auditorio"
              v-model="auditorium_id"
              name="auditoriums"
              :item-text="'name'"
              :item-value="'id'"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="6" xs="12">
            <v-text-field
              ref="link_youtube"
              v-model="link_youtube"
              outlined
              label="Link de Youtube"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!miniature"
              v-model="miniature"
              :rules="rules"
              @change="onMiniatureChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Miniatura"
              :messages="['Para una mejor visualización, usar un foto cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              max-width="380px"
              v-if="miniature"
              wei>
              <v-img
                contain
                :src="url_miniature"
                class="grey lighten-2"
                height="240px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteMiniature()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        outlined
        class="mt-4"
      >
        <v-row class="pa-4">
          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Speakers:</h3>
          </v-col>

          <v-col
            cols="12"
          >
            <v-select
              v-model="speakers"
              :items="speakers_edition"
              item-text="name"
              item-value="id"
              label="Skeapers"
              multiple
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        outlined
        class="mt-4"
      >
        <v-row class="pa-4">
          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Moderador:</h3>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              @click="newModerator()">
              Agregar moderador
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="moderators"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Actividades por página',
              }"
              mobile="true"
            >
              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="deleteModerator(item)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'activitiesProgramEdition', params: { edition_id:this.edition_id, program_id:this.program_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        color="primary"
        @click="saveActivity()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="dialog_new_moderator"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          Nuevo Moderador
        </v-card-title>

        <v-card-text class="pa-8">
          <v-text-field 
            outlined
            label="Nombre" 
            v-model="name_moderator"
            :maxlength="50"
            :counter="50"
            :rules="[v => (v || '' ).length <= 49 || 'La descripción no debe tener mas de 50 caracteres']">
          </v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_new_moderator=false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addModerator()"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'newSponsorsEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      dialog_new_moderator:false,

      edition_id:null,
      program_id:null,

      name:null,
      description:null,
      place: null,
      all_day:true,
      start_time:null,
      finish_time: null,
      target_audience: null,

      miniature:null,
      url_miniature:null,

      auditorium_id:null,
      auditoriums:[],

      type_of_activities:[],
      type_of_activity_id: null,

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      speaker_id:null,
      speakers_edition:[],
      speakers: [],

      moderator_id: null,

      name_moderator: '',
      moderators:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '75%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '25%'
        }
      ],
    }),

    methods:{
      async getTypeOfActivities()
      {
        await axios.get('type-of-activities').then(response =>{
          this.type_of_activities = response.data.data.type_of_activities
          if(this.type_of_activities.length>0){
            this.type_of_activity_id = this.type_of_activities[0].id
          }
        }).catch(error => {
          console.log(error);
        })
      },

      async getAuditoriums(){
        await axios.get('admin/editions/'+this.edition_id+'/auditoriums').then(response =>{
          this.auditoriums = response.data.data.auditoriums

          if(this.auditoriums.length>0){
            this.auditorium_id = this.auditoriums[0].id
          }
        }).catch(error => {
          console.log(error);
        })
      },

      async getSpeakers(){
        await axios.get('admin/editions/'+this.edition_id+'/speakers').then(response =>{
          this.speakers_edition = response.data.data.speakers
        }).catch(error => {
          console.log(error);
        })
      },

      async saveActivity()
      {
        this.loading_btn = true

        let formData= new FormData()

        if(this.name){
          formData.append('name', this.name)
        }

        if(this.type_of_activity_id){
          formData.append('type_of_activity_id', this.type_of_activity_id)
        }
        
        if(this.description){
          formData.append('description', this.description);
        }

        if(this.target_audience){
          formData.append('target_audience', this.target_audience);
        }

        if(this.place){
          formData.append('place', this.place);
        }

        formData.append('all_day', this.all_day);

        if(this.start_time){
          formData.append('start_time', this.start_time);
        }
        
        if(this.finish_time){
          formData.append('finish_time', this.finish_time);
        }

        if(this.auditorium_id){
          formData.append('auditorium_id', this.auditorium_id);
        }

        if(this.link_youtube){
          formData.append('link_youtube', this.link_youtube);
        }

        if(this.miniature){
          formData.append('miniature', this.miniature);
        }
        
        if(this.edition_id){
          formData.append('edition_id', this.edition_id);
        }

        if(this.program_id){
          formData.append('program_id', this.program_id);
        }

        formData.append('speakers', this.speakers);

        formData.append('moderators', JSON.stringify(this.moderators) );
        
        const url = 'admin/editions/'+this.edition_id+'/program-edition/'+this.program_id+'/activities'
        try {
          await axios({
            method: 'post',
            url: url,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'activitiesProgramEdition', params: { edition_id: this.edition_id, program_id: this.program_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          this.loading_btn = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onMiniatureChange() {
        this.url_miniature = URL.createObjectURL(this.miniature);
      },

      deleteMiniature(){
        this.miniature=null
        this.url_miniature=null
      },

      newModerator(){
        this.name_moderator = ''
        this.dialog_new_moderator = true
      },
      
      addModerator(){
        this.moderators.push({'name':this.name_moderator})
        this.dialog_new_moderator = false
      },

      deleteModerator(item){
        const newArray = this.moderators.filter((element) => element !== item);

        this.moderators = newArray
      }
    },
    created(){
      Promise.all([
        this.edition_id = this.$route.params.edition_id,
        this.program_id = this.$route.params.program_id,
        this.getTypeOfActivities(),
        this.getAuditoriums(),
        this.getSpeakers()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
